<template>
    <van-row class="bbottom">
        <van-col span="24">
            {{$store.state.siteinfo.sitename}}
            <p class="gspt">{{$store.state.siteinfo.subname}}</p>
        </van-col>
    </van-row>
</template>

<script>
    export default {
        name: "Bottom_comp",
        data(){
            return {
                sitename:'',
                subname: '',

            }
        },
        mounted(){
          //  this.setSiteTitle();
        },
        methods:{
            // setSiteTitle(){
            //     this.$nextTick(function () {
            //         this.sitename = this.$store.state.siteinfo.sitename;
            //         this.subname = this.$store.state.siteinfo.subname;
            //     })
            // }
    }
    }
</script>

<style scoped lang="scss">
    .bbottom{
        padding-bottom: 60px;
        color: #666;
        font-size: 20px;
    .gspt{
        font-size: 14px;
    }
    }
</style>
